import { InventoryTransaction } from './inventory-transaction';
import { AuditTrail } from '@card-software/nexus-models';
import { EntityKey } from './keys/entity-key';

export enum FinishedGoodsTransferStatus {
  Draft,
  ReadyForTransfer,
  InRoute,
  Received,
  Voided,
}

export interface FinishedGoodsTransferInsert extends Omit<FinishedGoodsTransfer, 'id' | 'number'> {
  id?: undefined;
  number?: undefined;
}

export interface FinishedGoodsTransfer extends AuditTrail {
  id: string;
  number: string;
  initiatorNumber?: string;
  status: number;
  initiator: EntityKey;
  fromLocationCode: string;
  locationName?: string; // Display purpose
  inventoryTransactions?: InventoryTransaction;
  rollNumbers: string[]; //we will store here too for display purposes
}

export interface FinishedGoodsTransferSearchCommand {
  searchTerm?: string;
  statuses?: number[];
  initiator?: EntityKey;
}

export interface RollsInOtherTransfersResponse {
  rollNumbersInTransfer: string[];
}

export interface FinishedGoodTransferCuadraje {
  finishedGoodTransferId: string;
  items: FinishedGoodTransferCuadrajeItem[];
}

export interface FinishedGoodTransferCuadrajeItem {
  fabricCode: string;
  colorReference?: string;
  productOrderNumber?: string;
  requiredQuantityInPounds: number;
  alreadyInFinishedGoodsQuantityInPounds: number;
  thisTransferQuantityInPounds: number;
  projectedQuantityInPounds: number;
  alreadyPercentage: number;
  projectedPercentage: number;
  clientTolerancePercentage?: number;
  clientShortagePercentage?: number;
  exceedsTolerance: boolean;
}
